module.exports = __webpack_public_path__ + "img/ko_img3.3df6b668.png";